import { useEffect, useRef } from 'react';
import { InputOTP } from '@amigoapp/doca-react';

export function Otp({ loading, onChange }) {
    const containerRef = useRef(null);

    useEffect(() => {
        const firstInput = containerRef.current?.querySelector('input');
        firstInput?.focus();
    }, []);

    return (
        <div ref={containerRef} className="doca-flex doca-justify-center doca-items-center doca-mb-5">
            <InputOTP
                length={5}
                onChange={onChange}
                required
                type="tel"
                disabled={loading}
            />
        </div>
    );
};
